<template>
  <div
    v-if="paneles"
    class="Home"
  >
    <div
      class="Search"
    >
      <form class="filters">
        <BaseSelect
          v-model="disciplina"
          :value="disciplina"
          :label="$t('HOME.DISCIPLINE')"
          tag="disciplina"
          :options="dicName"
        />

        <BaseSelect
          v-model="province"
          :value="province"
          :label="$t('HOME.PROVINCE')"
          tag="province"
          :options="terName"
          @change.native="getTerId()"
        />
      </form>
    </div>

    <div class="tit">
      <h2 class="title">
        {{ $t('HOME.LIST') }}
      </h2>
    </div>

    <div
      class="result"
    >
      <ul>
        <li
          v-for="(panel, i) in filteredItems"
          :key="i"
        >
          <router-link
            :to="`/authors/${panel.id}`"
          >
            <AuthorCard

              :author="panel"
            />
          </router-link>
        </li>
      </ul>
    </div>
  </div>

  <div v-else>
    <BaseLoader />
  </div>
</template>

<script>
import { get } from 'vuex-pathify';
import AuthorCard from '@/components/AuthorCard.vue';

export default {
  components: {
    AuthorCard,
  },

  data() {
    return {
      results: false,
      // category: undefined,
      disciplina: '',
      province: '',
      locality: '',
      // pane: undefined,
    };
  },

  computed: {
    ...get('authorsModule', [
      'getCategory',
      'getTerritory',
      'getLocality',
      'getPanels',
    ]),

    paneles: get('authorsModule/paneles'),

    filteredPanels() {
      return this.paneles.filter(panel => panel.userdatas.length);
    },

    isVisible() {
      return this.$route.meta.form;
    },

    getDic() {
      return this.getCategory();
    },

    dicName() {
      if (!this.getDic) return undefined;
      return this.getDic.reduce((acc, disciplina) => ({ ...acc, [disciplina.id]: disciplina.txt }), {});
    },

    getTer() {
      return this.getTerritory();
    },

    terId() {
      if (!this.getTer) return undefined;
      return this.getTer.reduce((acc, province) => ({ ...acc, [province.id]: province.id }), {});
    },


    terName() {
      if (!this.getTer) return undefined;
      return this.getTer.reduce((acc, province) => ({ ...acc, [province.id]: province.txt }), {});
    },

    getLoc() {
      return this.getLocality();
    },

    locName() {
      if (!this.getLoc) return undefined;
      return this.getLoc.reduce((acc, locality) => ({ ...acc, [locality.id]: locality.txt }), {});
    },

    filteredCategory() {
      if (this.disciplina === '') return this.filteredPanels;

      const filteredPanels = this.filteredPanels.filter((panel) => {
        const filteredDisciplinas = panel.userdatas.filter(disciplina => disciplina.disciplina.id === parseInt(this.disciplina, 10));

        return filteredDisciplinas.length > 0;
      });

      return filteredPanels;
    },

    filteredItems() {
      let prov = [];
      if (this.province === '' || this.province === 'Todas') return this.filteredCategory;

      prov = this.filteredCategory.filter(panel => panel.Territorio.id === parseInt(this.province, 10));
      if (this.locality === '' || this.locality === 'Todas') return prov;
      prov = prov.filter(panel => panel.Municipio.id === parseInt(this.locality, 10));

      return prov;
    },
  },


  async created() {
    // calls to store action

    await this.$store.dispatch('authorsModule/fetchDisciplinas');
    await this.$store.dispatch('authorsModule/fetchTerritorios');
    await this.$store.dispatch('authorsModule/fetchPaneles');
  },
  methods: {
    showModal() {
    },

    getTerId() {
      if (this.province === '') {
        this.$store.dispatch('authorsModule/resetLocality');
        this.locality = '';
      } else {
        this.$store.dispatch('authorsModule/fetchMunicipios', this.province)
          .then(() => {

          })

          .catch(() => {

          });
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.Home {
    background-image: url('~@/assets/images/background/back-1.jpg');
    .Search{
      padding-top: 20px;
      .filters {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        gap: 60px;
        margin: auto auto 0;
        color: white;
        z-index: 10;
        max-width: 1000px;
        width: 100%;
        .BaseSelect{
          ::v-deep{
            select{
              max-width: 230px;
            }
          }
        }
        @media #{$breakpoint-lg-max} {
          flex-direction: column;
          width: 350px;
          margin: 0 auto 2rem;
        }
      }
    }
  .tit{
    padding-top: 2.5rem;

    .title{
      font-size: 1.9rem;
      -webkit-text-stroke: .5px black;
      color: white;
      text-align: center;
      height: 40px;
      padding-top: 13px;


    }
  }
  .result {
    max-width: 1300px;
    margin: 0 auto;
    color: rgb(172, 25, 25);
    ul {
      padding-top: 2rem;
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr) );
      li {
        // height: 300px;
        padding: 1rem 0;
      }
    }
    a {
      color: inherit;
      text-decoration: none;
    }
  }
}
</style>
